import * as Sentry from '@sentry/nextjs'
import { replayIntegration } from '@sentry/react'
const isDeployment =
  process.env.NEXT_PUBLIC_ENV === 'preview' ||
  process.env.NEXT_PUBLIC_ENV === 'production'

export const setUser = (id: string, email: string, username?: string): void => {
  // Only add username if it exists
  const user = { id, email, ...(username && { username }) }
  if (isDeployment) {
    const client = Sentry.getClient()
    // Dynamically add Replay only once (after SDK v8 upgrade Replay is created via replayIntegration())
    if (client && !client.getIntegrationByName?.('Replay')) {
      client.addIntegration?.(
        replayIntegration({
          maskAllText: false,
          blockAllMedia: false,
          maskAllInputs: false,
        })
      )
    }

    Sentry.setUser(user)
  } else {
    // In non-deployment environments just log the user (object form for readability)
    // eslint-disable-next-line no-console
    console.log('Set Sentry user:', user)
  }
}
